export default __webpack_public_path__ + "static/media/mahebeach03.98fe1e03.jpg";